import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["method", "timeout", "responseType", "withCredentials", "originalResponse"],
  _excluded2 = ["headers", "originalResponse"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import axios from 'axios';
export function axiosBaseRequest(_ref) {
  var _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'get' : _ref$method,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 40000 : _ref$timeout,
    _ref$responseType = _ref.responseType,
    responseType = _ref$responseType === void 0 ? 'json' : _ref$responseType,
    _ref$withCredentials = _ref.withCredentials,
    withCredentials = _ref$withCredentials === void 0 ? true : _ref$withCredentials,
    _ref$originalResponse = _ref.originalResponse,
    originalResponse = _ref$originalResponse === void 0 ? false : _ref$originalResponse,
    config = _objectWithoutProperties(_ref, _excluded);
  var response = axios(_objectSpread({
    method: method,
    timeout: timeout,
    responseType: responseType,
    withCredentials: withCredentials
  }, config));
  return originalResponse ? response : response.then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}

/**
 * Обертка добавляет в запрос хидер X-Requested-With: XMLHttpRequest
 * Нужно для того, чтобы b2c-бэк воспринимал реквест как ajax
 * Иначе возможны баги в АЗ при обращении с другой витрины
 */

export function axiosBeelineRequest(_ref3) {
  var headers = _ref3.headers,
    _ref3$originalRespons = _ref3.originalResponse,
    originalResponse = _ref3$originalRespons === void 0 ? false : _ref3$originalRespons,
    config = _objectWithoutProperties(_ref3, _excluded2);
  originalResponse = originalResponse;
  return axiosBaseRequest(_objectSpread(_objectSpread({}, config), {}, {
    originalResponse: originalResponse,
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      'X-Requested-With': 'XMLHttpRequest'
    })
  }));
}